import client from './client';

export const getPatientAssessmentsApi = params => client().get('/patient-answers', params);

export const getNextQuestionApi = ({ assessmentId, ...params }) => client().post(`/questionnaire/${assessmentId}`, params);

export const getAllPatientAnswersApi = ({ assessmentId, ...params }) => client().get(`/questionnaire/${assessmentId}`, params);
